// @flow

import type {Cancelable} from '../types/cancelable';
import {makeSimpleRequest} from '../util/ajax';
import type {RailRouteRequest, RailStationRequest} from '../ui/server_side_structs';
import {postRailRouteRequestParameters, getRailStationParameters} from '../ui/server_side_structs';
/**
 * Rail Service
 */
export const Rail = {
    // postRouteReport, // future work
    // geocodeStation, // future work

    /**
     * This API will generate the Lat/Lon route path.
     * @param{RailRouteRequest} Options Request options
     *
     * @example
     * const request = TrimbleMaps.Rail.postRoutePath({
     *   stops: [{
     *     format: TrimbleMaps.Common.RailStationFormat.STATION_STATE,
     *     name: 'Denver CO',
     *     railroad: 'UP'
     *   },
     *   {
     *     format: TrimbleMaps.Common.RailStationFormat.STATION_STATE,
     *     name: 'Oakland CA',
     *     railroad: 'UP'
     *   }],
     *   options: {
     *     routingPreference: TrimbleMaps.Common.RailRoutePreference.PRACTICAL,
     *     terminalSwitching: true,
     *     amtrakRoutes: true,
     *     intermodalOnlyStations: true,
     *     distUnit: TrimbleMaps.Common.RailDistanceUnit.MILES
     *   },
     *   callback: function(error, response) {
     *     if (error === null) {
     *       console.log('success', response);
     *     } else {
     *       console.log('failure', error)
     *     }
     *   }
     * });
     */
    postRoutePath, // postRailRoutePath in v1.2

    /**
     * The API for locating rail freight station(s) by SPLC code in the database. Up to one station in an array will be returned in this release.
     * @param {RailStationRequest} Options Request options
     *
     * @example
     * const railStationLocation = TrimbleMaps.Rail.getStations({
     *   splc: '344770000',
     *   callback: function(error, response) {
     *     if (error === null) {
     *       console.log('success', response);
     *     } else {
     *       console.log('failure', error)
     *     }
     *   }
     * });
     */
    getStations // getRailStations in v1.2
};

function postRoutePath(options: RailRouteRequest): Cancelable {
    const requestParameters = postRailRouteRequestParameters(options);
    const request = makeSimpleRequest('POST', requestParameters, options.callback);
    return {cancel: () => request.cancel()};
}

function getStations(options: RailStationRequest): Cancelable {
    const requestParameters = getRailStationParameters(options);
    const request = makeSimpleRequest('GET', requestParameters, options.callback);
    return {cancel: () => request.cancel()};
}

